import { Component } from '@theme/component';

/**
 * Announcement banner custom element that creates a seamless infinite marquee.
 * 
 * @extends {Component}
 */
export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.setupMarquee();
  }

  setupMarquee() {
    const track = this.querySelector('.announcement-bar__track');
    const content = this.querySelector('.announcement-bar__content');
    
    if (!track || !content) return;

    // Set CSS custom property for animation duration
    const speed = this.getAttribute('speed') || '20';
    track.style.setProperty('--marquee-duration', `${speed}s`);

    // Calculate content width and adjust animation if needed
    this.adjustMarqueeSpeed();
    
    // Handle resize events
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.adjustMarqueeSpeed(), 150);
    });
  }

  adjustMarqueeSpeed() {
    const track = this.querySelector('.announcement-bar__track');
    const content = this.querySelector('.announcement-bar__content');
    
    if (!track || !content) return;

    const containerWidth = this.offsetWidth;
    const contentWidth = content.offsetWidth;
    
    // If content is shorter than container, adjust speed to maintain consistent velocity
    if (contentWidth < containerWidth) {
      const baseSpeed = parseFloat(this.getAttribute('speed') || '20');
      const adjustedSpeed = (baseSpeed * contentWidth) / containerWidth;
      track.style.setProperty('--marquee-duration', `${Math.max(adjustedSpeed, 5)}s`);
    }
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}